import { 
  ButtonLink, 
  ButtonLooks, 
  ButtonSizes,
  ListItem, 
  StandardDropdown 
} from '@brandfolder/react';
import classnames from 'classnames';
import React, { FunctionComponent, useEffect, useState } from 'react';

import { useFetch } from '@api/ApiHelper';
import { ApiResponseObject } from '@api/v4/ApiResponseTypes';
import { BrandguideListResponse, BrandguideServer } from '@api/v4/brandguides/brandguidesTypes';

import classes from './styles/brandguide-header-list.module.scss';

export const BrandguideHeaderList: FunctionComponent = () => {

  const { loading, response } = useFetch<BrandguideListResponse>({
    url: `/api/v4/${BFG.resource.type}s/${BFG.resource.key}/brandguides?fields=v2`
  });

  const [options, setOptions] = useState<ListItem[]>([]);

  const brandguideUrl = (brandguide: ApiResponseObject<BrandguideServer, 'brandguides'>): string => {
    if (brandguide.attributes.v2) {
      return `${BFG.brandguideUrl}?redirect=${brandguide.attributes.slug}`;
    }
    return `${BFG.brandguideV1Url}/${brandguide.attributes.slug}`;
  };

  const renderOptions = (): void => {
    const listItems: ListItem[] = response && response.data.map((brandguide) => {
      return {
        children: (
          <ButtonLink 
            className={classes.brandguideButtonLink} 
            fullWidth={true}
            href={brandguideUrl(brandguide)}
            look={ButtonLooks.Default} 
            size={ButtonSizes.Large} 
            target="_blank"
          >
            {brandguide.attributes.name}
          </ButtonLink>
        ), 
        key: brandguide.id
      };
    });
    setOptions(listItems);
  };

  useEffect(() => {
    if (response) {
      renderOptions();
    }
  }, [response]); // eslint-disable-line react-hooks/exhaustive-deps

  const brandguides = response?.data;

  const hasNoBrandguides = brandguides?.length === 0;
  if (hasNoBrandguides === true) return null;
  
  const hasOneBrandguide = brandguides?.length === 1;
  const brandguideText = hasOneBrandguide ? bfTranslate('Brandguide') : bfTranslate('Brandguides');
  const dropdownText = brandguides ? `${brandguides.length} ${brandguideText}` : '';

  return (
    <StandardDropdown
      buttonProps={{ className: classes.brandguideDropdownButton, endIconProps: { className: classes.caret } }}
      className={classnames(classes.brandguideDropdown)}
      id="brandguide-dropdown"
      labels={{
        loaderLabel: 'Loading'
      }}
      listItems={options}
      listProps={{
        style: {
          width: 270
        }
      }}
      loading={loading}
    >
      {dropdownText}
    </StandardDropdown>
  );
};